import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { KeyRound, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { PASSWORD_EXPIRY_WARNING_DAYS } from '../../utils/passwordPolicy';

// Şifre politikası — şifrenin süresi yaklaşınca içerik alanının üstünde tek satırlık uyarı.
// Süresi dolan şifreyle oturum hiç açılmaz (sunucu 403); bu bant kullanıcıyı ondan ÖNCE
// profilindeki şifre değiştirme çekmecesine götürür. Kapatma yalnız bu sekme oturumu içindir.
const DISMISS_KEY = 'flexbee_password_expiry_notice_dismissed';

const readDismissed = () => {
  try {
    return sessionStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    return false;
  }
};

export default function PasswordExpiryNotice() {
  const { t } = useTranslation();
  const auth = useAuth();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(readDismissed);

  const days = auth?.user?.passwordExpiresInDays;
  if (days == null || days > PASSWORD_EXPIRY_WARNING_DAYS) return null;
  // Profil sayfası süreyi kendi güvenlik kartında gösterir ve çekmeceyi oradan açar.
  if (dismissed || location.pathname === '/profile') return null;

  const dismiss = () => {
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch { /* ignore */ }
    setDismissed(true);
  };

  return (
    <Bar role="status" data-testid="password-expiry-notice">
      <KeyRound size={16} aria-hidden="true" />
      <Text>{days === 0 ? t('passwordExpiryNotice.today') : t('passwordExpiryNotice.inDays', { count: days })}</Text>
      <Link to="/profile?changePassword=1">{t('passwordExpiryNotice.action')}</Link>
      <CloseButton type="button" onClick={dismiss} aria-label={t('common.close')} title={t('common.close')}>
        <X size={14} />
      </CloseButton>
    </Bar>
  );
}

const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background: ${({ theme }) => theme.colors.auxiliar.warning}1F;
  border-bottom: 1px solid ${({ theme }) => theme.colors.auxiliar.warning}55;
  color: #7A5B00;
  font-family: ${({ theme }) => theme.metrics.font.family};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};

  a {
    font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
    color: ${({ theme }) => theme.colors.primary.main};
    white-space: nowrap;
  }
`;

const Text = styled.span`
  flex: 1;
  min-width: 0;
`;

const CloseButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`;
